import {
  vk,
  ok,
  smileSocial,
  mail,
  twitter,
  MIRpay,
  MTSpay,
  SBPpayNew,
  YandexpayNew
} from '@images';

const footerLinks = {
  aboutUs: [
    { url: '/about', title: 'Почему мы?' },
    { url: '/delivery', title: 'Заказ и доставка' },
    { url: '/warranty', title: 'Легкий возврат' },
    { url: '/reviews', title: 'Отзывы' },
    { url: '/suppliers', title: 'Поставщикам' },
    { url: '/news', title: 'Новости' },
    { url: '/shop', title: 'Гастрономы' },
    { url: '/ustrichnye-bary-v-moskve', title: 'Устричные бары' },
    { url: '/contacts', title: 'Контакты' }
  ],
  forСlients: [
    { url: '/faq', title: 'Спросите у шефа' },
    { url: '/cook', title: 'Рецепты' },
    // { url: '/catalog/services', title: 'Услуги' },
    { url: '/test-drive', title: 'Тест-драйвы' },
    { url: '/promotions', title: 'Действующие акции' },
    { url: '/loyalty-program', title: 'Программа лояльности' },
    { url: '/opt', title: 'Бизнесу' },
    { url: '/vacancies', title: 'Вакансии' }
  ]
};

const payments = [
  {
    img: SBPpayNew,
    height: '32',
    width: '80',
    className: 'payment-icon-large'
  },
  { img: MIRpay, height: '32', width: '80', className: 'payment-icon-medium' },
  { img: MTSpay, height: '32', width: '80', className: 'payment-icon-medium' },
  {
    img: YandexpayNew,
    height: '32',
    width: '80',
    className: 'payment-icon-small'
  }
  // { img: Plite, height: '32', width: '80', className: 'payment-icon-small' }
];

const social = [
  { img: vk },
  { img: ok },
  { img: twitter },
  { img: smileSocial },
  { img: mail }
];

export default { social, payments, footerLinks };
